/**
* @Component Name: OrderHistoryComponent
* @Module: Home
* @Module Functionality : To display the customer order history details
* @Creation Date: August 12,2017
* @Author: sbaireddy
* @Version: 1.0
*/
import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import * as Constants from '../../shared/constants';
import { STORES, ORDER_STATUS } from '../../shared/form.constants';
import { Cart } from '../../shared/modal/cart';
import { Customer } from '../../shared/modal/customer';

import { SharedService } from '../../shared/shared.service';
import { LookupService } from '../../services/lookup.service';
import { CartService } from '../../services/cart.service';
import { CustomerService } from '../../services/customer.service';

@Component({
    selector: 'order-history-cmp',
   // moduleId: module.id,
    templateUrl: 'order-history.component.html',
    styleUrls: ['order-history.component.css']
})

export class OrderHistoryComponent implements OnInit, OnDestroy {
    private COMPONENT_NAME: string = 'OrderHistoryComponent';
    karmaTestResult: any = {};
    orderStatusItems: any[];
    orderStoresItems: any[];
    @Input() customer: Customer;
    cart: Cart;
    storeId: number; // updating storeid
    @ViewChild('conflictModel') conflictModel: any;
    conflictOrderId: number;

    constructor(
        public router: Router,
        public sharedService: SharedService,
        public lookupService: LookupService,
        public cartService: CartService,
        public customerService: CustomerService) {
    }

    /**
     * This function is used to initialize the directive/component after Angular
     * first displays the data-bound properties.It is invoked only once when the
     * directive is instantiated.Here it is initializing all the states, payment methods and card types
     * @returns void
     */
    ngOnInit(): void {
        const METHOD_NAME: string = 'ngOnInit()';
        console.log('OrderHistoryComponent.ngOnInit()>>Start.');        
        this.sharedService.storeId.subscribe((val: number) => {
            this.storeId = val;
            console.log('updated storeid' + this.storeId);
        });
        this.orderStatusItems = ORDER_STATUS.filter(orderStatusItem => orderStatusItem);
        this.orderStoresItems = STORES.filter(orderStoreItem => orderStoreItem);
        // making sure, there are credit line info

        
 }
 /**
     * Cleanup just before Angular destroys the directive/component.
     * Unsubscribe Observables and detach event handlers to avoid memory leaks.
     * @returns void
*/
ngOnDestroy(): void {
    const METHOD_NAME: string = 'ngOnDestroy()';
    this.customer = null;
    this.cart = null;
    this.orderStatusItems = null;
    this.orderStoresItems = null;
    this.karmaTestResult = null;
}

    /**
     * This function is used to get the name of reftype based of reftype.
     * @param  {string} refType contains valid reftype
     * @returns string
     */
    getRefTypeLabel(refType: string): string {
        const METHOD_NAME: string = 'getRefTypeLabel()';
        if (refType === 'NEW_ORDER_TYPE' || refType ==='new') {
            return Constants.REF_TYPE_NEW ;
        } else if (refType === 'RETURN_ORDER_TYPE') {
            return Constants.REF_TYPE_RETURN;
        } else if (refType === 'EXCHANGE_ORDER_TYPE') {
            return Constants.REF_TYPE_EXCHANGE;
        } else if (refType === 'CREDIT_ORDER_TYPE') {
            return Constants.REF_TYPE_CREDIT;
        }
        return 'Not Found';
    }
    /**
     * This function is used to get the item key,value pairs based on getchannel label.
     * @param  {number} storeId contains valid number for storeid
     * @returns string
     */
    getChannelLabel(storeId: number): string {
        const METHOD_NAME: string = 'getChannelLabel()';
        for (const item of this.orderStoresItems) {
            if (item.key === storeId) {
                return item.value;
            }
        }
        return 'Not Found';
    }
    /**
     * This function is used to get the status from orderstatusitems key,value pairs
     * @param  {string} status contains valid status
     * @returns string
     */
    getStatusLabel(status: string): string {
        const METHOD_NAME: string = 'getStatusLabel()';
        // console.log('OrderHistoryComponent.getStatusLabel()>>Start.');
        this.orderStatusItems = ORDER_STATUS.filter(orderStatusItem => orderStatusItem);
        if (this.orderStatusItems) {
            for (const item of this.orderStatusItems) {
                if (item.key === status) {
                    return item.value;
                }
            }
        }
        return 'Not Found';
    }
    /**
     * This function is used to get the cart and cart summary from cart service.
     * @param  {number} orderId contains valid order number.
     * @returns void
     */
    showOrderSummary(orderId: number): void {
        const METHOD_NAME: string = 'showOrderSummary()';
        this.sharedService.addLogging(this.COMPONENT_NAME, METHOD_NAME, 'Display order summary');
       // console.log("OrderHistoryComponent.showOrderSummary()>>Start.");
        if (this.cartService.getCart()) {
            this.conflictOrderId = orderId;
            this.conflictModel.show();
        } else {
            this.lookupService.setOrder(null);
            this.sharedService.showSpinner(true); // spinner
            this.cartService.getCartSummary(this.storeId, orderId).subscribe(result => {
                this.karmaTestResult = result;
                this.sharedService.showSpinner(false); // spinner
                this.cart = result;
                this.showOrderCustomer(orderId);
            }, error => {
                this.sharedService.showSpinner(false); // spinner
                this.sharedService.showErrorMessage(error, true);
                console.error('error=>' + error)
            });
        }

    }
    /**
     * This function is used to getCustomerProfile from customer service.
     * @param  {number} orderId contains valid order number.
     * @returns void
     */
    showOrderCustomer(orderId: number): void {
        const METHOD_NAME: string = 'showOrderCustomer()';
        // console.log("OrderHistoryComponent.showOrderCustomer()>>Start.");
        this.sharedService.showSpinner(true); // spinner
        this.customerService.getCustomerProfile(this.storeId, orderId, null).subscribe(result => {
            this.karmaTestResult = result;
            this.sharedService.showSpinner(false); // spinner
            if (this.cart) {
                this.cart.customer = result;
                this.lookupService.setOrder(this.cart);
                //this.router.navigate(['home/search/order-detail'], { queryParams: { orderId: this.cart.fullOrderId} });
            }
        }, error => {
            this.sharedService.showSpinner(false); // spinner
            this.sharedService.showErrorMessage(error, true);
            console.error('error=>' + error)
        });
    }
    /**This function is used to set cart to null and to show order summary based on conflict orderid
     * @returns void
     */
    resolveConflicts(): void {
        const METHOD_NAME: string = 'resolveConflicts()';
        this.cartService.setCart(null);
        this.conflictModel.hide();
        this.showOrderSummary(this.conflictOrderId);
    }



    /**
     * This function is used to get overall summary of the order.
     * @param  {number} orderId - orderId of the user.
     * @returns void
     */
    showSAPOrderSummary(orderId: number): void {
        const METHOD_NAME: string = 'showSAPOrderSummary()';
        this.sharedService.addLogging(this.COMPONENT_NAME, METHOD_NAME, 'Display sap order summary');
        // clearing order details from local storage
      
        this.lookupService.setOrder(null);
        this.sharedService.showSpinner(true); // spinner
        this.cartService.getSapItemDetails(this.storeId, orderId).subscribe(result => {
                this.karmaTestResult = result;
                this.sharedService.showSpinner(false); // spinner                 
                this.lookupService.setOrder(result);                
                //this.router.navigate(['home/search/order-detail']);
        }, error => {
            this.sharedService.showSpinner(false); // spinner
            this.sharedService.showErrorMessage(error, true);
            console.error('error=>' + error);
        });
    }

}
